/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const CATEGORYAVAILABLE_ADD = 'CATEGORYAVAILABLE_ADD';
export const CATEGORYAVAILABLE_BEGIN = 'CATEGORYAVAILABLE_BEGIN';
export const CATEGORYAVAILABLE_FAILURE = 'CATEGORYAVAILABLE_FAILURE';
export const CATEGORYAVAILABLE_CLEAR = 'CATEGORYAVAILABLE_CLEAR';

export function fetchCategoryAvailable(data) {
	return async dispatch => {
        dispatch(categoryAvailableBegin());
        await ApiService.getCategoriesAvailable(data)
			.then(
				result => {
                    let normalized = normalizeById(result.Data, 'idCategory');
                    dispatch(categoryAvailableAdd(normalized));
					return normalized;
				},
				error => {
                    dispatch(categoryAvailableError());
					throw ({error: error, message: 'An error ocurred'});
				}
			)
	};
}


export const categoryAvailableBegin = () => ({
    type: CATEGORYAVAILABLE_BEGIN,
});

export const categoryAvailableAdd = data => ({
    type: CATEGORYAVAILABLE_ADD,
	payload: { data }
})

export const categoryAvailableError = () => ({
    type: CATEGORYAVAILABLE_FAILURE,
})

export const categoryAvailableClear = () =>({
    type: CATEGORYAVAILABLE_CLEAR,
})

